import { Injectable } from '@angular/core';

import { AccountInfo } from '../models';
import { Feed } from './feed';

@Injectable()
export abstract class AccountPnlFeed extends Feed<AccountInfo> {}
